import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import DashboardPlugin from './dashboard-plugin'
import App from './App.vue'

import AOS from 'aos'
import 'aos/dist/aos.css'

import VueYandexMetrika from 'vue-yandex-metrika'
//import VueAnalytics from 'vue-analytics'

// router setup
import routes from './routes/routes'

Vue.config.productionTip = false

// plugin setup
Vue.use(VueRouter)
Vue.use(DashboardPlugin)

// configure router
const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

Vue.use(VueYandexMetrika, {
    id: 71390890,
    router: router,
    env: process.env.NODE_ENV
})

/*Vue.use(VueAnalytics, {
    id: 'G-3S0MN482N2',
    router
})*/

router.beforeEach((to, from, next) => {
  const publicPages = ['Home', 'SpecialistRegister', 'Confirm', 'Lobby', 'Page', 'Box', 'OauthRedirect', 'PaymentOrderRoute']
  const authRequired = !publicPages.includes(to.name)
  const loggedIn = localStorage.getItem('access_token');

  if (authRequired && !loggedIn) {
    store.commit('setRoute', to)
    next('/')
  }
  next()
})


// router.afterEach(to => {
//   if (to.fullPath !== '/') {
//     store.commit('setRoute', to)
//   }
// })

import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify'

Vue.directive('app-scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

new Vue({
  router,
  store,
  vuetify,
  created () {
    AOS.init({ offset: 20 })
  },
  render: h => h(App)
}).$mount('#app')
